import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";

export type AppDialogProps = {
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  trigger?: React.ReactNode;
  showCloseIcon?: boolean;
  size?: "sm" | "md" | "lg" | number;   
  className?: string;                   
  overlayClassName?: string;             
  container?: HTMLElement | null;
};

const sizeClass = (size: AppDialogProps["size"]) => {
  if (typeof size === "number") return "app-dialog-content-custom";
  switch (size) {
    case "sm":
      return "app-dialog-content-sm";
    case "lg":
      return "app-dialog-content-lg";
    case "md":
    default:
      return "app-dialog-content-md";
  }
};

export function AppDialog({
  open,
  defaultOpen,
  onOpenChange,
  title,
  description,
  children,
  footer,
  trigger,
  showCloseIcon = true,
  size = "md",
  className = "",
  overlayClassName = "",
  container,
}: AppDialogProps) {
  return (
    <Dialog.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
      {trigger && <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>}

      <Dialog.Portal container={container ?? undefined}>
        <Dialog.Overlay className={`app-dialog-overlay ${overlayClassName}`} />
        <Dialog.Content
          className={`app-dialog-content ${sizeClass(size)} ${className}`}
          style={typeof size === "number" ? ({ ["--app-dialog-max-w" as any]: `${size}px` }) : undefined}
        >
          {(title || showCloseIcon) && (
            <div className="app-dialog-header">
              {title ? (
                <Dialog.Title className="app-dialog-title">{title}</Dialog.Title>
              ) : (
                <span />
              )}
              {/* {showCloseIcon && (
                <Dialog.Close className="app-dialog-close" aria-label="Close">
                  <span aria-hidden>✕</span>
                </Dialog.Close>
              )} */}
            </div>
          )}

          {description && (
            <Dialog.Description className="app-dialog-description">
              {description}
            </Dialog.Description>
          )}

          <div className="app-dialog-body">{children}</div>

          {footer && <div className="app-dialog-footer">{footer}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export const AppDialogClose = Dialog.Close;
